document.addEventListener('DOMContentLoaded', function () {
  const SITE_ID = '5op9sn';
  const SECTION_ID = 'search-grid';
  const searchInput = document.getElementById('search-input');
  const suggestionList = document.getElementById('predictive-search-results-queries-list');
  const searchRow = document.querySelector('.search-row'); 
  const searchPageResults = document.querySelector('.search-results'); 
  const searchTitle = document.querySelector('.search-title');
  const showAllButton = document.querySelector('.show-all-result'); // your button
  let swiperInstance = null;
  let debounceTimer;

  // Debounce 
  function debounce(func, delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
  }

  // Swiper Init 
  // function initSwiper() {
  //   if (swiperInstance && typeof swiperInstance.destroy === 'function') {
  //     swiperInstance.destroy(true, true);
  //     swiperInstance = null;
  //   }

  //   if (document.querySelector('.search-drawer-slider.swiper')) {
  //     setTimeout(() => {
  //       swiperInstance = new Swiper('.search-drawer-slider.swiper', {
  //         slidesPerView: 'auto',
  //         loop: true,
  //         freeMode: { enabled: true },
  //         speed: 1000,
  //       });
  //     }, 50);
  //   }
  // }

    function initSwiper() {
    if (swiperInstance && typeof swiperInstance.destroy === 'function') {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    const el = document.querySelector('.search-drawer-slider.swiper');
    if (!el) return;

    setTimeout(() => {
      swiperInstance = new Swiper(el, {
        slidesPerView: 'auto',
        loop: false,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumBounce: true,
        },
        grabCursor: true,
        speed: 800,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
        },
        keyboard: {
          enabled: true,
        },
      });
    }, 50);
  }

  // Quick Add Button 
  function quickAddButton() {
    document.querySelectorAll('.variant-grid').forEach(sizeList => {
      sizeList.addEventListener('click', e => {
        e.preventDefault();
        const variant_id = sizeList.dataset.id;
        const formData = { items: [{ id: variant_id, quantity: 1 }] };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        })
          .then(r => r.json())
          .then(() => {
            if (typeof load_cart === 'function') load_cart();
          })
          .catch(console.error);
      });
    });
  }

  // Color Variant Switch 
  function colorVariantClick() {
    if (window.innerWidth > 1024) {
      document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          const attVal = this.getAttribute('data-id');
          const productItem = this.closest('.product-item');
          if (!productItem) return;

          const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
          innerGrids.forEach(function (innerGrid) {
            if (attVal === innerGrid.getAttribute('data-id')) {
              innerGrids.forEach(g => g.classList.remove('active'));
              innerGrid.classList.add('active');
            }
          });
        });
      });
    }
  }

  // Fetch Suggestions (Left Drawer)
  async function fetchSuggestions(query) {
    const url = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&q=${encodeURIComponent(
      query
    )}&resultsPerPage=8&page=1`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (!suggestionList) return;
      suggestionList.innerHTML = '<li class="sugg-title line-18">Suggested:</li>';

      if (!data.results || data.results.length === 0) {
        suggestionList.innerHTML += `<li class="predictive-search__list-item">No suggestions found</li>`;
        return;
      }

      data.results.slice(0, 8).forEach(p => {
        const li = document.createElement('li');
        li.className = 'predictive-search__list-item';
        li.innerHTML = `
          <a href="/products/${p.handle}" class="hover-opacity predictive-search__item link link--text">
            <div class="predictive-search__item-content predictive-search__item-content--centered">
              <p class="predictive-search__item-heading line-18">${p.name.split(" - ")[0].trim()}</p>
            </div>
          </a>`;
        suggestionList.appendChild(li);
      });
    } catch (err) {
      console.error('Suggestion error:', err);
    }
  }

  // Fetch Products (Drawer + Page, Pagination + Loader)
  async function fetchProducts(query, targetElement, limitToTen = false) {
    const loader = document.querySelector('.look-cart-loader-inner');
    if (loader) loader.style.display = 'flex';

    let allResults = [];
    let page = 1;
    let hasMore = true;
    const perPage = 100;

    try {
      while (hasMore) {
        const url = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&q=${encodeURIComponent(
          query
        )}&resultsPerPage=${perPage}&page=${page}`;

        const res = await fetch(url);
        const data = await res.json();

        if (data.results && data.results.length > 0) {
          allResults = allResults.concat(data.results);

          if (limitToTen && allResults.length >= 10) {
            allResults = allResults.slice(0, 10);
            hasMore = false;
          } else if (data.pagination?.nextPage) {
            page++;
          } else {
            hasMore = false;
          }
        } else {
          hasMore = false;
        }
      }

      if (searchTitle && !limitToTen) {
        searchTitle.innerHTML = `Showing ${allResults.length} results for “${query}”`;
      }

      targetElement.innerHTML = '';

      if (allResults.length === 0) {
        targetElement.innerHTML = `<div class="no-results">No products found.</div>`;
        if (loader) setTimeout(() => (loader.style.display = 'none'), 500);
        return;
      }

      const handles = allResults.map(p => p.handle).filter(Boolean);
      const sections = await Promise.all(
        handles.map(async handle => {
          try {
            const r = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
            const json = await r.json();
            return { handle, html: json[SECTION_ID] };
          } catch (err) {
            console.warn('Section fetch failed:', handle, err);
            return { handle, html: `<div class="error">Failed to load ${handle}</div>` };
          }
        })
      );

      sections.forEach(({ html }) => {
        const slide = document.createElement('div');
        slide.classList.add('search-column', 'product-item');
        if (targetElement.classList.contains('search-row')) {
          slide.classList.add('swiper-slide');
        }
        slide.innerHTML = html;
        targetElement.appendChild(slide);
      });
      if (searchTitle && !limitToTen) {
        if (document.querySelectorAll('.search-column.product-item>.shopify-section>.snippet-product-grid').length) {
          var wc_length = document.querySelectorAll('.search-column.product-item>.shopify-section>.snippet-product-grid').length;
          searchTitle.innerHTML = `Showing ${wc_length} results for “${query}”`;
        }
      }
      if (targetElement.classList.contains('search-row')) initSwiper();
      quickAddButton();
      colorVariantClick();
    } catch (err) {
      console.error('Fetch error:', err);
      targetElement.innerHTML = `<div class="error">Error fetching results.</div>`;
    } finally {
      if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
    }
  }

  // Drawer Live Search 
  if (searchInput) {
    searchInput.addEventListener('keyup', function () {
      const query = searchInput.value.trim();
      if (!query) {
        if (suggestionList) suggestionList.innerHTML = '';
        if (searchRow) searchRow.innerHTML = '';
        // if (showAllButton) showAllButton.style.display = 'none';
        return;
      }

      if (showAllButton) {
        showAllButton.href = `/pages/search-results-page?q=${encodeURIComponent(query)}`;
      }

      debounce(() => {
        fetchSuggestions(query);
        if (searchRow) fetchProducts(query, searchRow, true);
      }, 400);
    });
  }

  // Redirect on Enter 
  if (searchInput) {
    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = searchInput.value.trim();
        if (query) {
          window.location.href = `/pages/search-results-page?q=${encodeURIComponent(query)}`;
        }
      }
    });
  }

  // Search Page Auto Load 
  const urlParams = new URLSearchParams(window.location.search);
  const pageQuery = urlParams.get('q');
  if (pageQuery && searchPageResults) {
    fetchProducts(pageQuery, searchPageResults, false);
  }
});
